module.exports = __webpack_public_path__ + "static/media/cv1.e5311607.png";